import type { ArticleData } from '~/graphql/generated/graphql';
import type { Article } from '~/types/Learn/Article';

/**
 * Single source of truth for the draft/published gate: preview mode reads the
 * draft content (falling back to published), everyone else only ever sees
 * published content — never leak draft-only copy to a public reader.
 */
export const useArticleTemplateData = (article: Ref<Article>, preview: Ref<boolean>) => {
  const data = computed<ArticleData | null>(() =>
    (preview.value
      ? article.value.draftContent?.data ?? article.value.publishedContent?.data
      : article.value.publishedContent?.data) ?? null,
  );

  return { data };
};
